export default __webpack_public_path__ + "static/media/TOKYO.efd7a1a8.png";